<template lang="pug">
.modalPlayerCloseComponent
  modal-content-component(
    :title="title"
    @yes="onSubmitButtonClick"
    @no="onCloseButtonClick"
  )
</template>

<script>
import ModalContentComponent from './PlayerModalCloseContent'
export default {
  components: {
    ModalContentComponent
  },
  props: {
    title: {
      type: String,
      default: 'Ты уверен, что хочешь закрыть?'
    }
  },
  emits: ['close', 'submit'],
  methods: {
    onSubmitButtonClick () {
      this.$emit('submit')
      this.$emit('close')
    },
    onCloseButtonClick () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="sass" scoped>
.modalPlayerCloseComponent
  z-index: $zIndexModal
</style>
